import React, { useState, Fragment } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader, Modal } from "reactstrap";

function Validation({ open, messages, toggle }) {

    return (
        <Fragment>
            <Modal isOpen={open} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    Input Error
                </ModalHeader>
                <ModalBody>
                    <h6 className="my-2">Correct the input and try again.</h6>
                    {messages.length > 0 &&
                        <Fragment>
                            <ol className="m-2" style={{ listStyle: 'disc' }}>
                                <Fragment>
                                    {messages.map((m) => <li className="m-2">{m}</li>)}
                                </Fragment>
                            </ol>

                        </Fragment>}

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}> Close </Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    );
}

export default Validation;